import React, { createContext, useContext, useState } from 'react';

const NavbarContext = createContext();

export const NavbarProvider = ({ children }) => {
  const [groupValues, setGroupValues] = useState({
    registeredUsersCount: 0,
    complianceUsersCount: 0,
    totalUsersCount: 0,
    nonComplianceUsersCount: 0,
    bannedUsersCount: 0,
    usersCount: 0,
    visitorsCount: 0,
  });

  const updateGroupValues = (newValues) => {
    setGroupValues((prevValues) => ({ ...prevValues, ...newValues }));
  };

  return (
    <NavbarContext.Provider value={{ groupValues, updateGroupValues }}>
      {children}
    </NavbarContext.Provider>
  );
};

export const useNavbar = () => {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error('useNavbar must be used within a NavbarProvider');
  }
  return context;
};